<template>
  <div class="send_redpack">
    <el-dialog
      title="发送红包"
      :visible="true"
      width="800px"
      top="10vh"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div class="content" v-loading="loading">
        <div class="repack_dom">
          <div class="repack_bg">
            <div class="repack">
              <div class="repack_title">{{ title || '--' }}</div>
            </div>
          </div>
        </div>
        <div class="form_box">
          <div class="item_col">
            <div class="item_title">群发应用</div>
            <div class="form_item">
              <div class="label">应用：</div>
              <el-select class="el_select" v-model="form.agent_id" placeholder="请选择">
                <el-option
                  v-for="item in appOptions"
                  :key="item.agent_id"
                  :label="item.agent_name"
                  :value="item.agent_id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="item_col">
            <div class="item_title">群发对象</div>
            <div class="form_item">
              <select-sending-range
                title="请选择发送范围"
                @confirm="confirmSelectRange"
                ref="selectSendingRange"
              ></select-sending-range>
            </div>
          </div>
          <div class="item_col">
            <div class="item_title">定时群发</div>
            <el-switch
              v-model="form.send_strategy"
              :width="40"
              active-color="#2F96FF"
              inactive-color="#D2D4D9"
              :active-value="2"
              :inactive-value="1"
            ></el-switch>
            <div v-if="form.send_strategy == 2">
              <div class="hint">
                你可以选择5分钟后，在一周内定时群发，成功设置后不支持修改不可取消。
              </div>
              <div class="date_picker_row">
                <el-date-picker
                  v-model="form.date"
                  type="date"
                  placeholder="选择日期"
                  class="date_picker"
                  format="MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  @change="changeDatePicker"
                  :editable="false"
                  :picker-options="pickerOptionsDay"
                ></el-date-picker>
                <el-time-picker
                  class="time_select"
                  v-model="form.startTime"
                  :picker-options="pickerOptionsMinute"
                  :default-value="defaultValue"
                  value-format="HH:mm:ss"
                  placeholder="选择当前时间的后5分钟"
                ></el-time-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_col" v-loading="loading">
        <div @click="handleClose">取消</div>
        <div @click="onSubmit">确认发布</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { formatTime } from '@/utils/time.js';
import selectSendingRange from '../selectSendingRange';
import { EyaoSaasGetAppInfoList, sendRedPackApi } from '@/api/enterpriseWeChatManagement';
export default {
  components: {
    selectSendingRange,
  },
  props: ['id', 'title'],
  data() {
    return {
      appOptions: [],
      form: {
        date: null,
        startTime: null,
        send_strategy: 1,
        agent_id: null,
        user_info: [],
      },
      defaultValue: null,
      pickerOptionsMinute: {
        selectableRange: '',
      },
      pickerOptionsDay: {
        disabledDate(time) {
          const tempTime = time.getTime();
          const nowTime = Date.now();
          return tempTime < nowTime - 86400000 || tempTime > nowTime + 604800000;
        },
      },
      nowDay: formatTime(new Date(), 'yyyy-mm-dd'),
      loading: false,
    };
  },
  mounted() {
    // 获取应用列表
    this.eyaoSaasGetAppInfoList();
  },
  methods: {
    // 预留方法 返显数据
    setSelectRangeDefaultValue() {
      this.$refs.selectSendingRange.setDefaultValue();
    },
    // 提交
    onSubmit() {
      if (!this.form.agent_id) {
        this.$message.error('请选择应用');
        return;
      }
      if (!this.form.user_info.length) {
        this.$message.error('请选择范围');
        return;
      }
      const form = {
        expected_time: '',
        agent_id: this.form.agent_id,
        send_strategy: this.form.send_strategy,
        redpack_id: this.id,
      };
      form.user_info = this.form.user_info.map((e) => {
        return {
          user_id: e.userid,
          user_name: e.name,
        };
      });
      this.checkTimeIsLegal().then((tiemRes) => {
        if (tiemRes.status === 1) {
          form.expected_time = String(tiemRes.sendTime / 1000);
        }
        this.loading = true;
        sendRedPackApi(form)
          .then((res) => {
            this.loading = false;
            if (!res.err_code) {
              this.$message.success('发送成功');
              setTimeout(() => {
                this.$emit('sendSuccess');
              }, 2000);
            } else {
              this.$message.error(res.err_msg || res);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message || e);
          });
      });
    },
    // 检查时间
    checkTimeIsLegal() {
      return new Promise((resolve, reject) => {
        if (this.form.send_strategy == 2) {
          console.log('来了');
          console.log(this.form.date);
          console.log(this.form.startTime);
          if (!this.form.date || !this.form.startTime) {
            this.$message.error('请把时间填选完整');
            reject();
          }
          // 定时群发时间必须为五分钟以后  定时群发时间必须为一周之内
          const sendTime = new Date(`${this.form.date} ${this.form.startTime}`).getTime();
          console.log(sendTime, 'sendTime');
          if (sendTime < new Date().getTime() + 1000 * 60 * 5) {
            this.$message.error('定时群发时间必须为五分钟以后');
            reject();
          }
          resolve({ status: 1, sendTime });
        }
        resolve({ status: 2 });
      });
    },
    // 确认发送人数
    confirmSelectRange(arr) {
      this.form.user_info = arr;
    },
    // 获取应用列表
    async eyaoSaasGetAppInfoList() {
      const form = {
        page_index: 1,
        page_size: 9999,
      };
      const res = await EyaoSaasGetAppInfoList(form);
      try {
        this.appOptions = res.list;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 关闭
    handleClose() {
      this.$emit('close');
    },
    // 日历组件
    changeDatePicker(e) {
      if (e === this.nowDay) {
        // 如果选择的时当天 则只能选择当前时间的5分钟后
        this.setPickerOptions();
      }
    },
    setPickerOptions() {
      this.form.startTime = '';
      this.defaultValue = new Date().getTime() + 360000;
      let future = new Date(this.defaultValue);
      future = formatTime(future, 'hh:ii:ss');
      this.pickerOptionsMinute = {
        selectableRange: `${future} - 23:59:59`,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
